import heroPage from 'components/hero-page/hero-page';
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import shopPage from 'components/woocommerce/shop/index';

heroPage();
breadcrumbs();
shopPage();

